import {css} from "lit-element/lit-element.js";
export default css`
.mc-toast .content{display:none}`;
